import {
  SlTooltip
} from "./chunk.5UHNODB4.js";

// src/components/tooltip/tooltip.ts
var tooltip_default = SlTooltip;
SlTooltip.define("sl-tooltip");

export {
  tooltip_default
};
